import React from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { dictionary } from '../../../dictionary';

const InvoiceConversion = ({ conversion, setConversion, startStage, setStartStage, possibleStages }) => {
  return (
    <div className="field-row">
      <div className="col" style={{ marginRight: '0.5rem' }}>
        <label>{dictionary.esp_dialog_invoice_conversion}</label>
        <InputNumber
          style={{ width: '100%' }}
          value={conversion !== null ? conversion : 0}
          onChange={(e) => {
            setConversion(e.value);
          }}
          mode="currency"
          currency="PLN"
          maxFractionDigits={4}
          minFractionDigits={4}
        />
      </div>
      <div className="col">
        <label>{dictionary.esp_dialog_invoice_start_stage}</label>
        <Dropdown
          style={{ width: '100%' }}
          value={startStage}
          options={possibleStages}
          onChange={(e) => {
            setStartStage(e.value);
          }}
        />
      </div>
    </div>
  );
};

export default InvoiceConversion;
